module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', _vm._l((_vm.components), function(c) {
    return _c('div', [_c('a', {
      on: {
        "click": function($event) {
          _vm.click(c.info.id)
        }
      }
    }, [_c('mu-icon', {
      staticStyle: {
        "vertical-align": "middle"
      },
      attrs: {
        "value": _vm.show ? 'keyboard_arrow_down' : 'keyboard_arrow_right'
      },
      on: {
        "click": function($event) {
          _vm.show = !_vm.show
        }
      }
    }), _vm._v("\n            " + _vm._s(c.info.name))], 1), _vm._v(" "), _vm._l((c.slots), function(slot, key) {
      return _c('div', {
        directives: [{
          name: "show",
          rawName: "v-show",
          value: (_vm.show),
          expression: "show"
        }]
      }, [(Object.keys(c.slots).filter(function (slot) { return c.slots[slot].length; }).length) ? _c('componentTree', {
        attrs: {
          "components": _vm.slotToComponents(c.slots[key])
        }
      }) : _vm._e()], 1)
    })], 2)
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-a945f026","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/componentTree.vue
// module id = 570
// module chunks = 1